import bgHero from "./../../public/img/pattern3.jpg";

export const logoStyles = { width: "100px", height: "100px", objectFit: "contain" }

export const heroStyle = {
            backgroundImage: `url(${bgHero})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "63vh",
            position: "relative"
        }

export const contactUsStyle = {
                background: "white",
                color: "blue",
                borderRadius: "9999px",
                padding: "12px 32px",
                fontWeight: "600"
            }

export const contactUsBody = {
            background: "linear-gradient(90deg, #3b82f6, #06b6d4)"
        }

export const packageButton = {
                            background: "linear-gradient(90deg, #16a34a, #22c55e)",
                            border: "none",
                            borderRadius: "9999px",
                            padding: "10px 28px",
                            fontWeight: "600"
                        }

export const collPackageStyle = {
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(12px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    transition: "all 0.3s ease"
                    }

export const dimmerStyles = {
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background:
                "linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.4))"
            }

export const mainButtonStyles = {
                background:
                    "linear-gradient(90deg, #06b6d4, #3b82f6)",
                border: "none",
                color: "white",
                padding: "12px 32px",
                borderRadius: "9999px",
                fontWeight: "600",
                transition: "all 0.3s ease"
            }

export const logoutButtonStyles = {
                background:
                    "linear-gradient(90deg, #cb6415, #ff5500)",
                border: "none",
                padding: "12px 32px",
                borderRadius: "9999px",
                fontWeight: "600",
                transition: "all 0.3s ease"
            }

export const navbarStyles = {
        background: "rgba(255, 255, 255, 0.86)",
        backdropFilter: "blur(12px)"
    }

export const navbarLogoStyles = { width: "90px", height: "60px", objectFit: "contain" }

export const navigationAnimation = { transition: "color 0.2s" }

export const listLogoStyles = { width: "50px", height: "50px", objectFit: "contain" }

export const listItemLogoStyles = { width: "55px", objectFit: "contain" }

export const listBankLogoStyles = { width: "40px", objectFit: "contain" }